import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => setupInputModeTracking())
  .catch(err => console.error(err));

function setupInputModeTracking(): void {
  const enableTabMode = () => {
    document.body.classList.add('user-is-tabbing');

    window.removeEventListener('keydown', handleKeydown);
    window.addEventListener('mousedown', disableTabMode);
    window.addEventListener('touchstart', disableTabMode);
  };

  const disableTabMode = () => {
    document.body.classList.remove('user-is-tabbing');

    window.removeEventListener('mousedown', disableTabMode);
    window.removeEventListener('touchstart', disableTabMode);
    window.addEventListener('keydown', handleKeydown);
  };

  const handleKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Tab') {
      enableTabMode();
    }
  };

  window.addEventListener('keydown', handleKeydown);
}
